import { create } from 'zustand';

const generateId = () => crypto.randomUUID();
export const useBundleStore = create((set, get) => ({
    /* ---------------------- STATE ---------------------- */
    bundles: [],
    directBundles: [],

    bundle: {
        id: '',
        name: '',
        code: '',
        items: [],
    },

    errors: {},
    isEditing: false,
    isDirectEditing: false,
    isEditingRow: false,
    isLoading: false,

    /* ---------------------- SETTERS ---------------------- */
    setIsEditingRow: (id) => set({ isEditingRow: id }),
    setIsLoading: (value) => set({ isLoading: value }),

    setName: (name) =>
        set((state) => ({
            bundle: { ...state.bundle, name },
        })),

    setCode: (code) =>
        set((state) => ({
            bundle: { ...state.bundle, code },
        })),

    /* ---------------------- ITEM OPERATIONS ---------------------- */
    addItem: (item) =>
        set((state) => ({
            bundle: {
                ...state.bundle,
                items: [...state.bundle.items, item],
            },
        })),

    updateItem: (id, updated) =>
        set((state) => ({
            bundle: {
                ...state.bundle,
                items: state.bundle.items.map((item) => (item.id === id ? { ...item, ...updated } : item)),
            },
        })),

    removeItem: (id) =>
        set((state) => ({
            bundle: {
                ...state.bundle,
                items: state.bundle.items.filter((item) => item.id !== id),
            },
        })),

    /* ---------------------- BUNDLE OPERATIONS ---------------------- */
    createNewBundle: () =>
        set({
            bundle: { id: generateId(), name: '', code: '', items: [] },
            isEditing: false,
            isEditingRow: false,
            isDirectEditing: false,
            errors: {},
        }),

    saveBundle: () =>
        set((state) => ({
            bundles: [...state.bundles, { ...state.bundle }],
        })),

    saveDirectBundle: () =>
        set((state) => ({
            directBundles: [...state.directBundles, { ...state.bundle }],
        })),

    updateBundle: () =>
        set((state) => ({
            bundles: state.bundles.map((b) => (b.id === state.bundle.id ? state.bundle : b)),
        })),

    deleteBundle: (id) =>
        set((state) => ({
            bundles: state.bundles.filter((b) => b.id !== id),
        })),

    /* ---------------------- EDIT HANDLERS ---------------------- */
    setEditBundle: (bundle) =>
        set({
            bundle: { ...bundle },
            isEditing: true,
            errors: {},
        }),

    setDirectEditBundle: (bundle) =>
        set({
            bundle: { ...bundle },
            isDirectEditing: true,
            errors: {},
        }),

    /* ---------------------- VALIDATION ---------------------- */
    validateBundle: () =>
        set((state) => {
            const errors = {};
            const { name, code, items } = state.bundle;

            if (!name.trim()) errors.name = 'Tuliskan nama dari product bundle untuk menyimpan mapping';
            if (!code.trim()) errors.code = 'Kode Product di Toko tidak boleh Kosong';
            if (items.length < 2) errors.items = 'Tambahkan minimal 2 produk untuk menyimpan mapping';

            return { errors };
        }),

    /* ---------------------- UTILS ---------------------- */
    hasUnsavedChanges: () => {
        const { name, code, items } = get().bundle;
        return name.trim() !== '' || code.trim() !== '' || items.length > 0;
    },

    /* ---------------------- RESETTERS ---------------------- */
    resetBundle: () =>
        set({
            bundle: { id: '', name: '', code: '', items: [] },
            isEditing: false,
            isEditingRow: false,
            errors: {},
        }),

    resetBundles: () =>
        set({
            bundles: [],
            directBundles: [],
            isEditing: false,
            isEditingRow: false,
            isDirectEditing: false,
            errors: {},
        }),
}));
